import type { CurriculumPhase, CurriculumRole } from "@curriculum-studio/core";

// The labels and chips the index rows and the document page share.
//
// ROLE (canonical / experiment / archived) reads as neutral fact: which document this is among its
// siblings is mostly carried by the index's own hierarchy, so its chip never competes for attention.
// PHASE is the only axis that carries colour, and it carries it through the `PhaseTracker` — colour
// there encodes the step's STATE (in progress / done / returned to) rather than which stage it is,
// which is what keeps a re-entered stage unmistakable from a completed one.
const FACT_CHIP = "rounded-full bg-zinc-100 px-2 py-0.5 text-[11px] font-medium text-zinc-600";

const ROLE_LABEL: Record<CurriculumRole, string> = {
  canonical: "Canonical",
  experiment: "Experiment",
  archived: "Archived",
};

export const PHASE_LABEL: Record<CurriculumPhase, string> = {
  structure: "Structure",
  exercises: "Exercises",
  published: "Published",
};

export const RoleChip = ({ role }: { readonly role: CurriculumRole }) => (
  <span className={FACT_CHIP}>{ROLE_LABEL[role]}</span>
);
